var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../localization/helpers.js';
let ConfirmOperationModal = class ConfirmOperationModal extends LitElement {
    constructor() {
        super(...arguments);
        this.title = msg('Confirm Operation', { id: 'modal.confirm.title', desc: 'Confirm operation modal title' });
        this.message = msg('Are you sure you want to proceed?', { id: 'modal.confirm.message', desc: 'Confirm operation modal message' });
        this.confirmText = CommonActions.confirm();
        this.currentInput = '';
    }
    handleInput(event) {
        const inputText = event.target.value;
        this.currentInput = inputText;
    }
    render() {
        return html `
      <div class="container">
        <h2>${this.title}</h2>
        <p>${this.message}</p>
        ${this.confirmText ? html `
            <p>${msg('Please copy the following text')} <strong>${this.confirmText}</strong> ${msg('to confirm:')} </p>
            <input-text .placeholder="${this.confirmText}" @input-text=${this.handleInput}></input-text>
        ` : ''}
        <div class="button-group">
          <simple-button variant="danger" special @button-click=${this._onConfirm} label="${CommonActions.confirm()}"></simple-button>
          <simple-button variant="secondary" @button-click=${this._onCancel} label="${CommonActions.cancel()}"></simple-button>
        </div>
      </div>
    `;
    }
    _onConfirm() {
        if (this.confirmText && this.currentInput !== this.confirmText) {
            return;
        }
        this.dispatchEvent(new CustomEvent('confirm', { bubbles: true, composed: true }));
    }
    _onCancel() {
        this.dispatchEvent(new CustomEvent('cancel', { bubbles: true, composed: true }));
    }
};
ConfirmOperationModal.styles = css `
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }

    .container {
      background: white;
      padding: 20px 30px;
      border-radius: 10px;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      text-align: center;
      max-width: 300px;
    }

    .container h2 {
      margin-top: 0;
      margin-bottom: 15px;
      color: #333;
    }

    .container p {
      margin: 0 0 20px 0;
      color: #555;
    }

    .container input-text {
      margin-bottom: 20px; /* Ajout d'espace entre l'input et les boutons */
    }

    .container .button-group {
      display: flex;
      justify-content: center;
      gap: 15px; /* Ajout d'espace entre les boutons */
      margin-top: 15px; /* Ajout d'espace entre l'input et les boutons */
    }

    .container button {
      padding: 8px 16px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 1rem;
    }
  `;
__decorate([
    property({ type: String })
], ConfirmOperationModal.prototype, "title", void 0);
__decorate([
    property({ type: String })
], ConfirmOperationModal.prototype, "message", void 0);
__decorate([
    property({ type: String })
], ConfirmOperationModal.prototype, "confirmText", void 0);
__decorate([
    state()
], ConfirmOperationModal.prototype, "currentInput", void 0);
ConfirmOperationModal = __decorate([
    localized(),
    customElement('confirm-operation-modal')
], ConfirmOperationModal);
export { ConfirmOperationModal };
//# sourceMappingURL=ConfirmOperationModal.js.map